/* Reference to visual ids in Power BI
Water usage per car: 2aaee6289f87897ddf44
Gas usage per car: 72fd86ea413ee4eb457e
Sewer usage per car: adce7743b7f41ff84d17
Electric usage per car: c0e3b25d6f7f02b61a49

Water cost per car: 0d96cfa3c8e0f03ac61f
Sewer cost per car:6463c2dedb3a529a4779
Electric cost per car:28d022e8824865b34378
Gas cost per car: eb342d3c878687bc3df6

Sewer/total washes: 28600657fdb9bf3c4d38
Electric/total washes: aab1000b702ae342f268
Gas/ total washes: b9af9aaccca69d445356
Water/ total washes: f11bb2be10d1a0d5c0e2

Rewash % by employee: 4918f8008876ae9d202f
Rewash % of volume by date:80dc4c449b77a439d905
*/

export const utilityVisualIds = {
  water: [
    { id: '2aaee6289f87897ddf44', title: 'usagePerCar' },
    { id: '0d96cfa3c8e0f03ac61f', title: 'costPerCar' },
    { id: 'f11bb2be10d1a0d5c0e2', title: 'totalWashes' },
  ],
  watersewer: [
    { id: '2aaee6289f87897ddf44', title: 'usagePerCar' },
    { id: '0d96cfa3c8e0f03ac61f', title: 'costPerCar' },
    { id: 'f11bb2be10d1a0d5c0e2', title: 'totalWashes' },
  ],
  gas: [
    { id: '72fd86ea413ee4eb457e', title: 'usagePerCar' },
    { id: 'eb342d3c878687bc3df6', title: 'costPerCar' },
    { id: 'b9af9aaccca69d445356', title: 'totalWashes' },
  ],
  electric: [
    { id: 'c0e3b25d6f7f02b61a49', title: 'usagePerCar' },
    { id: '28d022e8824865b34378', title: 'costPerCar' },
    { id: 'aab1000b702ae342f268', title: 'totalWashes' },
  ],
  sewer: [
    { id: 'adce7743b7f41ff84d17', title: 'usagePerCar' },
    { id: '6463c2dedb3a529a4779', title: 'costPerCar' },
    { id: '28600657fdb9bf3c4d38', title: 'totalWashes' },
  ],
  rewash: [
    { id: '80dc4c449b77a439d905', title: 'percentageOfVolumeByDate' },
    { id: 'd282e5ffa6e4dd290320', title: 'rewashByReason30Days' },
    { id: '4918f8008876ae9d202f', title: 'percentageByEmployee' },
  ],
};
